import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { Router } from "@angular/router";
import { LocationStrategy } from "@angular/common";
import { SharedHttp } from "../../../services/http-client.service";
import { ComponentService } from "../../../services/component.service";
import { PaymentInstructionsWalletModalComponent } from "../payment-instructions-wallet-modal/payment-instructions-wallet-modal.component";
import { AuthService } from "../../../services/auth.service";
/**
 * Deposit Wallet AUD Modal Component
 */
let DepositWalletAudModalComponent = class DepositWalletAudModalComponent {
    constructor(sanitizer, router, location, compService, httpClient, themeService, authService) {
        this.sanitizer = sanitizer;
        this.router = router;
        this.location = location;
        this.compService = compService;
        this.httpClient = httpClient;
        this.themeService = themeService;
        this.authService = authService;
        this.secondColor = '';
        this.accentColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.copied = false;
        this.sendButtonDisabled = true;
        this.sendButtonClicked = false;
        this.displayMessageForMFAReset = false;
        this.walletBlockedRemainingTime = '';
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
        if ('walletBlocked' in this.data) {
            if (this.data.walletBlocked) {
                this.displayMessageForMFAReset = true;
                this.authService.fetchUser().then(() => {
                    const user = JSON.parse(localStorage.getItem('user'));
                    this.walletBlockedRemainingTime = user.wallet_blocked_remaining_time;
                });
            }
        }
        if (!this.data.walletData.currency.fiat) {
            this.httpClient.get('wallet/deposit?customerWalletId=' + this.data.walletData.verboseId).subscribe((data) => {
                this.depositData = data;
            });
        }
    }
    close() {
        this.modal.destroy();
    }
    checkValidation() {
        if (!this.amount || typeof this.amount === 'undefined' || this.amount <= 0) {
            this.sendButtonDisabled = true;
            return;
        }
        if (this.amount.toString().split('.').length > 1 && this.amount.toString().split('.')[1].length > 2) {
            this.amount = Number(this.amount.toFixed(2));
        }
        this.sendButtonDisabled = false;
    }
    sendFiat() {
        if (this.sendButtonDisabled) {
            return;
        }
        this.sendButtonClicked = true;
        this.httpClient.get('wallet/getfiatdepositpaymentdetails').subscribe((data) => {
            let user = JSON.parse(localStorage.getItem('user'));
            let address = user.address ? (', ' + user.address) : '';
            let city = user.city ? (', ' + user.city) : '';
            let userDetails = user.name + address + city;
            const paymentDetails = {
                bankAccount: data['fiatDepositPaymentDetails']['bank_account'],
                paymentNumber: data['fiatDepositPaymentDetails']['payment_number'],
                paymentPurpose: data['fiatDepositPaymentDetails']['payment_purpose'],
                paymentModelCode: data['fiatDepositPaymentDetails']['payment_model_code'],
                currency: this.data.walletData.currency.verboseId,
                amount: this.amount
            };
            this.httpClient.post('wallet/getipsqrcode', { paymentDetails: paymentDetails }).subscribe((ipsQRData) => {
                this.sendButtonClicked = false;
                this.close();
                this.compService.openModal(PaymentInstructionsWalletModalComponent, {
                    userDetails: userDetails,
                    merchDetails: ipsQRData['ipsQRData']['merchDetails'],
                    amount: this.amount,
                    currency: this.data.walletData.currency.verboseId,
                    paymentDetails: data['fiatDepositPaymentDetails'],
                    ipsQRCode: ipsQRData['ipsQRData']['ipsQR']['b64data']
                });
            });
        });
    }
    copyDepositAddress(address) {
        document.addEventListener('copy', (e) => {
            e.clipboardData.setData('text/plain', (address));
            e.preventDefault();
            document.removeEventListener('copy', null);
        });
        document.execCommand('copy');
        this.copied = true;
        setTimeout(() => {
            this.copied = false;
        }, 2000);
    }
};
DepositWalletAudModalComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: Router },
    { type: LocationStrategy },
    { type: ComponentService },
    { type: SharedHttp },
    { type: WebsiteThemeService },
    { type: AuthService }
];
DepositWalletAudModalComponent = __decorate([
    Component({
        selector: 'ecd-deposit-wallet-aud-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./deposit-wallet-aud-modal.component.html")).default
    })
], DepositWalletAudModalComponent);
export { DepositWalletAudModalComponent };
